import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */

import InMemoryStorage from './InMemoryStorage';
export var AWC_STORAGE_PREFIX = 'awc';
export var GLOBAL_IN_MEMORY_NAME = 'awcInMemoryStorageFallback';
// This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
export var envType = /*#__PURE__*/function (envType) {
  envType["DEV"] = "dev";
  envType["LOCAL"] = "local";
  envType["PROD"] = "prod";
  envType["STAGING"] = "staging";
  return envType;
}({});
export function isSupported(store) {
  var TEST_VALUE = 'test_value';
  if (!store) {
    return false;
  }
  try {
    var key = 'awc.storage.support';
    store.setItem(key, TEST_VALUE);
    var value = store.getItem(key);
    store.removeItem(key);

    // handle localStorage silently failing
    return value === TEST_VALUE;
  } catch (e) {
    // Can throw if localStorage is disabled
    return false;
  }
}
export function isQuotaExceeded(e) {
  var quotaExceeded = false;
  if (e.code) {
    switch (e.code) {
      case 22:
        quotaExceeded = true;
        break;
      case 1014:
        // Firefox
        if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
          quotaExceeded = true;
        }
        break;
      default:
        break;
    }
  } else if (e.number === -2147024882) {
    // Internet Explorer 8
    quotaExceeded = true;
  }
  return quotaExceeded;
}
var SafeStorage = /*#__PURE__*/_createClass(function SafeStorage(storageToUse) {
  var _this = this;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _classCallCheck(this, SafeStorage);
  _defineProperty(this, "getStore", function () {
    return _this.store;
  });
  _defineProperty(this, "getItem", function (key) {
    return _this.store.getItem(_this.createKey(key));
  });
  _defineProperty(this, "removeItem", function (key) {
    return _this.store.removeItem(_this.createKey(key));
  });
  _defineProperty(this, "setItem", function (key, value) {
    try {
      _this.store.setItem(_this.createKey(key), value);
    } catch (err) {
      if (isQuotaExceeded(err)) {
        _this.swapToInMemory();
        _this.store.setItem(_this.createKey(key), value);
      }
    }
  });
  _defineProperty(this, "swapToInMemory", function () {
    if (_this.store === InMemoryStorage || typeof window === 'undefined') {
      return;
    }
    var keys = Object.keys(_this.store || {});
    var inMemoryStorage;
    if (isSupported(window[GLOBAL_IN_MEMORY_NAME])) {
      inMemoryStorage = window[GLOBAL_IN_MEMORY_NAME];
    } else {
      inMemoryStorage = InMemoryStorage;
      if (!window[GLOBAL_IN_MEMORY_NAME]) {
        // If not already attached to window then attach our instance of InMemoryStorage
        // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
        // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
        window[GLOBAL_IN_MEMORY_NAME] = InMemoryStorage;
      }
    }
    keys.forEach(function (key) {
      if (key.indexOf(_this.getPrefix()) === 0) {
        var value = _this.store.getItem(key);
        if (value) {
          inMemoryStorage.setItem(key, value);
        }
      }
    });
    _this.store = inMemoryStorage;
  });
  _defineProperty(this, "clear", function () {
    return _this.store.clear();
  });
  _defineProperty(this, "key", function (index) {
    return _this.store.key(index);
  });
  _defineProperty(this, "getPrefix", function () {
    return _this.prefix;
  });
  _defineProperty(this, "createKey", function (key) {
    if (_this.prefix) {
      return "".concat(_this.getPrefix(), ".").concat(key);
    }
    return key;
  });
  this.options = options;
  var prefixes = [];
  if (options.useStoragePrefix === undefined || options.useStoragePrefix) {
    prefixes.push(AWC_STORAGE_PREFIX);
  }
  if (options.envPrefix && options.envPrefix !== envType.PROD) {
    prefixes.push(options.envPrefix);
  }
  this.prefix = prefixes.join('-');
  if (isSupported(storageToUse)) {
    this.store = storageToUse;
  } else {
    this.swapToInMemory();
  }
});
export { SafeStorage as default };